// extracted by mini-css-extract-plugin
module.exports = {"frame":"style_frame__1gz2Z","item":"style_item__3-ovK","circle":"style_circle__2RCoO","selected":"style_selected__2_fUh","icon":"style_icon__3Ysto","label":"style_label__2ZRUf"};